import { render, staticRenderFns } from "./section-features.vue?vue&type=template&id=20bd1884&scoped=true&"
import script from "./section-features.vue?vue&type=script&lang=js&"
export * from "./section-features.vue?vue&type=script&lang=js&"
import style0 from "./section-features.vue?vue&type=style&index=0&id=20bd1884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd1884",
  null
  
)

export default component.exports